import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_REGISTERED_NODES = '/xcipioNodes-2';

export const GET_REGISTERED_NODES = 'GET_REGISTERED_NODES';
export const GET_REGISTERED_NODES_PENDING = 'GET_REGISTERED_NODES_PENDING';
export const GET_REGISTERED_NODES_FULFILLED = 'GET_REGISTERED_NODES_FULFILLED';
export const GET_REGISTERED_NODES_REJECTED = 'GET_REGISTERED_NODES_REJECTED';

export const GET_REGISTERED_NODE = 'GET_REGISTERED_NODE';
export const GET_REGISTERED_NODE_PENDING = 'GET_REGISTERED_NODE_PENDING';
export const GET_REGISTERED_NODE_FULFILLED = 'GET_REGISTERED_NODE_FULFILLED';
export const GET_REGISTERED_NODE_REJECTED = 'GET_REGISTERED_NODE_REJECTED';

export const CREATE_REGISTERED_NODE = 'CREATE_REGISTERED_NODE';
export const CREATE_REGISTERED_NODE_PENDING = 'CREATE_REGISTERED_NODE_PENDING';
export const CREATE_REGISTERED_NODE_FULFILLED = 'CREATE_REGISTERED_NODE_FULFILLED';
export const CREATE_REGISTERED_NODE_REJECTED = 'CREATE_REGISTERED_NODE_REJECTED';
export const UPDATE_REGISTERED_NODE = 'UPDATE_REGISTERED_NODE';
export const UPDATE_REGISTERED_NODE_PENDING = 'UPDATE_REGISTERED_NODE_PENDING';
export const UPDATE_REGISTERED_NODE_FULFILLED = 'UPDATE_REGISTERED_NODE_FULFILLED';
export const UPDATE_REGISTERED_NODE_REJECTED = 'UPDATE_REGISTERED_NODE_REJECTED';
export const DELETE_REGISTERED_NODE = 'DELETE_REGISTERED_NODE';
export const DELETE_REGISTERED_NODE_PENDING = 'DELETE_REGISTERED_NODE_PENDING';
export const DELETE_REGISTERED_NODE_FULFILLED = 'DELETE_REGISTERED_NODE_FULFILLED';
export const DELETE_REGISTERED_NODE_REJECTED = 'DELETE_REGISTERED_NODE_REJECTED';

export const SELECT_REGISTERED_NODE = 'SELECT_REGISTERED_NODE';
export const GO_TO_REGISTERED_NODE_CREATE = 'GO_TO_REGISTERED_NODE_CREATE';
export const GO_TO_REGISTERED_NODE_EDIT = 'GO_TO_REGISTERED_NODE_EDIT';
export const GO_TO_REGISTERED_NODE_VIEW = 'GO_TO_REGISTERED_NODE_VIEW';
export const GO_TO_REGISTERED_NODE_COPY = 'GO_TO_REGISTERED_NODE_COPY';
export const GO_TO_REGISTERED_NODE_LIST = 'GO_TO_REGISTERED_NODE_LIST';

export enum RegisteredNodeMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export enum RegisteredNodePrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface RegisteredNode {
  id: string
  nodeName: string
  siteName: string
  nodeType: string
  topology: string
  ipAddr: string
  ipAddr6: string,
  status: string,
  city: string
  stateName: string
  country: string
  latitude: string
  longitude: string
  swVersion: string
  access?: string,
  group?: string
  owner?: string,
}

export interface RegisteredNodeServerResponse {
  id: string
  NODENAME: string
  SITENAME: string
  NODETYPE:string
  TOPOLOGY: string
  IPADDR:string
  IPADDR6: string
  STATUS: string
  CITY: string
  STATENAME: string
  COUNTRY: string
  LATITUDE: string
  LONGITUDE: string
  SWVERSION: string
  ACCESS?: string
  GROUP?:string
  OWNER?: string
}

export interface RegisteredNodeState {
  entities: RegisteredNode[]
  select: RegisteredNode[]
  single: RegisteredNode | null
}

export interface GetRegisteredNodeAction extends AnyAction {
  type: typeof GET_REGISTERED_NODES
  payload: AxiosPromise<ServerResponse<RegisteredNode | RegisteredNodeServerResponse>>
}

export interface GetRegisteredNodePendingAction extends AnyAction {
  type: typeof GET_REGISTERED_NODES_PENDING
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}
export interface GetRegisteredNodeFulfilledAction extends AnyAction {
  type: typeof GET_REGISTERED_NODES_FULFILLED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface GetRegisteredNodeRejectedAction extends AnyAction {
  type: typeof GET_REGISTERED_NODES_REJECTED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface GetSingleRegisteredNodeAction extends AnyAction {
  type: typeof GET_REGISTERED_NODE
  payload: AxiosPromise<ServerResponse<RegisteredNode | RegisteredNodeServerResponse>>
}

export interface GetSingleRegisteredNodePendingAction extends AnyAction {
  type: typeof GET_REGISTERED_NODE_PENDING
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}
export interface GetSingleRegisteredNodeFulfilledAction extends AnyAction {
  type: typeof GET_REGISTERED_NODE_FULFILLED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface GetSingleRegisteredNodeRejectedAction extends AnyAction {
  type: typeof GET_REGISTERED_NODE_REJECTED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface CreateRegisteredNodeThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface CreateRegisteredNodeAction extends AnyAction {
  type: typeof CREATE_REGISTERED_NODE
  payload: AxiosPromise<ServerResponse<RegisteredNode | RegisteredNodeServerResponse>>
}

export interface CreateRegisteredNodeFulfilledAction extends AnyAction {
  type: typeof CREATE_REGISTERED_NODE_FULFILLED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface CreateRegisteredNodeRejectedAction extends AnyAction {
  type: typeof CREATE_REGISTERED_NODE_REJECTED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface UpdateRegisteredNodeThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface UpdateRegisteredNodeAction extends AnyAction {
  type: typeof UPDATE_REGISTERED_NODE
  payload: AxiosPromise<ServerResponse<RegisteredNode | RegisteredNodeServerResponse>>
}

export interface UpdateRegisteredNodeFulfilledAction extends AnyAction {
  type: typeof UPDATE_REGISTERED_NODE_FULFILLED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface UpdateRegisteredNodeRejectedAction extends AnyAction {
  type: typeof UPDATE_REGISTERED_NODE_REJECTED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface DeleteRegisteredNodeThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface DeleteRegisteredNodeAction extends AnyAction {
  type: typeof DELETE_REGISTERED_NODE
  payload: AxiosPromise<ServerResponse<RegisteredNode | RegisteredNodeServerResponse>>
}

export interface DeleteRegisteredNodeFulfilledAction extends AnyAction {
  type: typeof DELETE_REGISTERED_NODE_FULFILLED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface DeleteRegisteredNodeRejectedAction extends AnyAction {
  type: typeof DELETE_REGISTERED_NODE_REJECTED
  payload: AxiosResponse<ServerResponse<RegisteredNode>>
}

export interface SelectRegisteredNode extends AnyAction {
  type: typeof SELECT_REGISTERED_NODE
  payload: RegisteredNode[]
}

export type RegisteredNodeActionTypes =
  GetRegisteredNodeAction |
  GetRegisteredNodePendingAction |
  GetRegisteredNodeFulfilledAction |
  GetRegisteredNodeRejectedAction |
  GetSingleRegisteredNodeAction |
  GetSingleRegisteredNodePendingAction |
  GetSingleRegisteredNodeFulfilledAction |
  GetSingleRegisteredNodeRejectedAction |
  DeleteRegisteredNodeAction |
  DeleteRegisteredNodeFulfilledAction |
  DeleteRegisteredNodeRejectedAction |
  CreateRegisteredNodeAction |
  CreateRegisteredNodeFulfilledAction |
  CreateRegisteredNodeRejectedAction |
  UpdateRegisteredNodeAction |
  UpdateRegisteredNodeFulfilledAction |
  UpdateRegisteredNodeRejectedAction |
  SelectRegisteredNode;
